import type { FC } from "react";

import type { ISubscribeNewsletter } from "./SubscribeNewsletter";
import SubscribeNewsletter from "./SubscribeNewsletter";

import * as cssPortal from "../shared/Portal.module.css";
import * as css from "./Newsletter.module.css";

export interface INewsletter {
    title: string;
    description: string;
    subscribeNewsletter: ISubscribeNewsletter;
}

export const Newsletter: FC<INewsletter> = (props) => (
    <div className={css.newsletterComponent}>
        <div className={cssPortal.standardContainer}>
            <h1>{props.title}</h1>
            <div className={css.description}>
                <h6 dangerouslySetInnerHTML={{ __html: props.description }} />
            </div>
        </div>
        {props.subscribeNewsletter && (
            <div className={css.reSubscribeNewsletter}>
                <SubscribeNewsletter {...props.subscribeNewsletter} />
            </div>
        )}
    </div>
);
